package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.api.datasource.cv.Activity
import io.horion.cv.components.widgets.DateRangeSelector
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.di.koinGet
import io.horion.cv.models.ActivityState
import io.horion.cv.styles.ActivityFullWidthFieldStyle
import io.horion.cv.styles.ActivityHalfWidthFieldStyle
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

@Composable
fun ActivityForm(
    index: Int,
    state: ActivityState,
    cvViewModel: CvViewModel = koinGet(),
    onDelete: () -> Unit,
    onComplete: () -> Unit,
) {
    val updateVM = {
        val updatedActivity = Activity(
            name = state.poste,
            enterprise = state.employeur,
            city = state.ville,
            started = "${state.moisDebut}-${state.anneeDebut}",
            ended = if (state.isOngoing) "En cours" else "${state.moisFin}-${state.anneeFin}",
            description = state.description
        )
        cvViewModel.updateActivity(index, updatedActivity)
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(25.px)
    ) {
        // Champ Poste avec les dimensions exactes du design
        TextFormField(
            label = "Poste",
            value = state.poste,
            onValueChange = {
                state.poste = it
                updateVM()
            },
            modifier = ActivityFullWidthFieldStyle.toModifier()
        )

        // Version Mobile (< MD) : Employeur & Ville l'un sous l'autre
        Box(modifier = Modifier
            .fillMaxWidth()
            .displayUntil(Breakpoint.LG)) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                TextFormField(
                    label = "Employeur",
                    value = state.employeur,
                    onValueChange = {
                        state.employeur = it
                        updateVM()
                    },
                    modifier = ActivityFullWidthFieldStyle.toModifier()
                )
                TextFormField(
                    label = "Ville",
                    value = state.ville,
                    onValueChange = {
                        state.ville = it
                        updateVM()
                    },
                    modifier = ActivityFullWidthFieldStyle.toModifier()
                )
            }
        }

        // Version Desktop / Tablette (>= MD) : Employeur & Ville côte-à-côte
        Box( modifier = Modifier
            .fillMaxWidth()
            .displayIfAtLeast(Breakpoint.LG)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(25.px)
            ) {
                TextFormField(
                    label = "Employeur",
                    value = state.employeur,
                    onValueChange = {
                        state.employeur = it
                        updateVM()
                    },
                    modifier = ActivityHalfWidthFieldStyle.toModifier()
                )

                TextFormField(
                    label = "Ville",
                    value = state.ville,
                    onValueChange = {
                        state.ville = it
                        updateVM()
                    },
                    modifier = ActivityHalfWidthFieldStyle.toModifier()
                )
            }
        }

        // Sélecteur de date (sans contrainte modifiée pour préserver son comportement d'origine)
        DateRangeSelector(
            startMonth = state.moisDebut,
            startYear = state.anneeDebut,
            endMonth = state.moisFin,
            endYear = state.anneeFin,
            isOngoing = state.isOngoing,
            onStartMonthChange = { state.moisDebut = it; updateVM() },
            onStartYearChange = { state.anneeDebut = it; updateVM() },
            onEndMonthChange = { state.moisFin = it; updateVM() },
            onEndYearChange = { state.anneeFin = it; updateVM() },
            onOngoingChange = {
                state.isOngoing = it
                if (it) {
                    state.moisFin = ""
                    state.anneeFin = ""
                }
                updateVM()
            }
        )

        // Description enrichie : retrouve exactement sa largeur 380px/500px/770px
        RichTextDescription(
            label = "Description",
            value = state.description,
            onValueChange = { html ->
                state.description = html
                updateVM()
            },
            modifier = ActivityFullWidthFieldStyle.toModifier()
        )

        // Boutons d'action
        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}